/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CertificationPlanStageStatusDto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
/**
 * CertificationPlanStageApi - axios parameter creator
 * @export
 */
export const CertificationPlanStageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Mówi, czy plany rozwojowe uczestników certyfikacji już wystartowały. Startuje je kampania cyklu rozwojowego wskazująca tę certyfikację - bez niej uczestnicy nie mogą założyć planu. Etap jest wystartowany, gdy taka kampania istnieje, również gdy zdążyła się zakończyć; pole `active` mówi, czy jeszcze trwa. Certyfikacja ma najwyżej jedną taką kampanię.
         * @summary Development-plan stage status of a certification
         * @param {number} certificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCertificationPlanStageStatus: async (certificationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getCertificationPlanStageStatus', 'certificationId', certificationId)
            const localVarPath = `/api/v2/certifications/{certificationId}/plan-stage`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CertificationPlanStageApi - functional programming interface
 * @export
 */
export const CertificationPlanStageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CertificationPlanStageApiAxiosParamCreator(configuration)
    return {
        /**
         * Mówi, czy plany rozwojowe uczestników certyfikacji już wystartowały. Startuje je kampania cyklu rozwojowego wskazująca tę certyfikację - bez niej uczestnicy nie mogą założyć planu. Etap jest wystartowany, gdy taka kampania istnieje, również gdy zdążyła się zakończyć; pole `active` mówi, czy jeszcze trwa. Certyfikacja ma najwyżej jedną taką kampanię.
         * @summary Development-plan stage status of a certification
         * @param {number} certificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCertificationPlanStageStatus(certificationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CertificationPlanStageStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCertificationPlanStageStatus(certificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificationPlanStageApi.getCertificationPlanStageStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CertificationPlanStageApi - factory interface
 * @export
 */
export const CertificationPlanStageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CertificationPlanStageApiFp(configuration)
    return {
        /**
         * Mówi, czy plany rozwojowe uczestników certyfikacji już wystartowały. Startuje je kampania cyklu rozwojowego wskazująca tę certyfikację - bez niej uczestnicy nie mogą założyć planu. Etap jest wystartowany, gdy taka kampania istnieje, również gdy zdążyła się zakończyć; pole `active` mówi, czy jeszcze trwa. Certyfikacja ma najwyżej jedną taką kampanię.
         * @summary Development-plan stage status of a certification
         * @param {number} certificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCertificationPlanStageStatus(certificationId: number, options?: RawAxiosRequestConfig): AxiosPromise<CertificationPlanStageStatusDto> {
            return localVarFp.getCertificationPlanStageStatus(certificationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CertificationPlanStageApi - interface
 * @export
 * @interface CertificationPlanStageApi
 */
export interface CertificationPlanStageApiInterface {
    /**
     * Mówi, czy plany rozwojowe uczestników certyfikacji już wystartowały. Startuje je kampania cyklu rozwojowego wskazująca tę certyfikację - bez niej uczestnicy nie mogą założyć planu. Etap jest wystartowany, gdy taka kampania istnieje, również gdy zdążyła się zakończyć; pole `active` mówi, czy jeszcze trwa. Certyfikacja ma najwyżej jedną taką kampanię.
     * @summary Development-plan stage status of a certification
     * @param {number} certificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationPlanStageApiInterface
     */
    getCertificationPlanStageStatus(certificationId: number, options?: RawAxiosRequestConfig): AxiosPromise<CertificationPlanStageStatusDto>;

}

/**
 * CertificationPlanStageApi - object-oriented interface
 * @export
 * @class CertificationPlanStageApi
 * @extends {BaseAPI}
 */
export class CertificationPlanStageApi extends BaseAPI implements CertificationPlanStageApiInterface {
    /**
     * Mówi, czy plany rozwojowe uczestników certyfikacji już wystartowały. Startuje je kampania cyklu rozwojowego wskazująca tę certyfikację - bez niej uczestnicy nie mogą założyć planu. Etap jest wystartowany, gdy taka kampania istnieje, również gdy zdążyła się zakończyć; pole `active` mówi, czy jeszcze trwa. Certyfikacja ma najwyżej jedną taką kampanię.
     * @summary Development-plan stage status of a certification
     * @param {number} certificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationPlanStageApi
     */
    public getCertificationPlanStageStatus(certificationId: number, options?: RawAxiosRequestConfig) {
        return CertificationPlanStageApiFp(this.configuration).getCertificationPlanStageStatus(certificationId, options).then((request) => request(this.axios, this.basePath));
    }
}

